// Base64 bridges hold encoded and decoded media simultaneously. Keep generated
// clips within a bounded memory budget before FileReader or native decoding.
export const MAX_NATIVE_SHARE_BYTES = 32 * 1024 * 1024;

export function nativeShareAssetError(file: Pick<File, "size">) {
  if (file.size <= 0) return "empty_asset";
  if (file.size > MAX_NATIVE_SHARE_BYTES) return "asset_too_large";
  return null;
}
